import axios from 'axios';
import { T } from '../../../traks';
import React, { useContext, useEffect, useState } from 'react';

import LinkGenerator from "./LinkGenerator"
import { APIGet, APIPost } from '../../../API';
import { RenderIf } from '../../../helpers/RenderIf';
import { ContentHeader } from '../DashboardPage';
import { Loading } from '../../../c/Loading';
import { AlertModal } from '../../../c/Modals';
import { CompanyDetails } from './CompanyDetails';
import CompanyDocuments from './CompanyDocuments';
import MeContext from '../../../MeContext';
import DashboardContext from '../../../contexts/dashboardContext';

const SettingsTabItem = ({ tab, tabId, setTab, children }) => {
	const activeClass = tab === tabId ? " primary-border-bottom-color fw_500 border-bottom  border-3 pb-2" : ""
	return (
		<div
			className={`me-4 cursor_pointer${activeClass}`}
			onClick={() => setTab(tabId)}
		>
			{children}
		</div >
	)
}

const Tab = (tabProps) => {
	return (
		<div className="d-flex border-bottom ">
			<SettingsTabItem {...tabProps} tabId={"CompanyDetails"}>
				<T>Company Settings</T>
			</SettingsTabItem>
			<SettingsTabItem {...tabProps} tabId={"Links"}>
				<T>Links</T>
			</SettingsTabItem>
			<SettingsTabItem {...tabProps} tabId={"CompanyDocuments"}>
				<T>Documents</T>
			</SettingsTabItem>
		</div>
	)
}


const SettingsContent = ({ children, settingsTab }) => {
	return React.Children.map(children, (child) =>
		<RenderIf condition={child.props.tabId === settingsTab} >
			<div className="mt-5">
				{child}
			</div>
		</RenderIf>
	)
};


const CompanySettings = ({ tabId, ...props }) => {
	const [settingsTab, setSettingsTab] = useState("CompanyDetails")
	const tabProps = {
		tab: settingsTab,
		setTab: setSettingsTab
	}
	const [files, setFiles] = useState([])
	const [companySettings, setCompanySettings] = useState(undefined)
	const { me } = useContext(MeContext);
	const { setActiveTab, setUpdateData, updateData } = useContext(DashboardContext)
	const { company_id } = me
	const userRoles = (me && me.roles) || [];
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [showAlert, setShowAlert] = useState(false)
	const [showLoading, setShowLoading] = useState(false)

	const getCompanySettings = () => {
		setShowLoading(true)
		const resource = "companies/" + company_id
		APIGet(resource).then(res => {
			setShowLoading(false)
			setCompanySettings(res.data)
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
			console.log(err)
		})
	}

	const saveSettings = (newSettings = null) => {
		if (!newSettings)
			newSettings = companySettings
		setShowLoading(true)
		const resource = "companies/" + company_id
		APIPost(resource, newSettings).then(res => {
			setShowLoading(false)
			setAlertType({ type: "success", text: "settings saved" })
			setShowAlert(true)
			setCompanySettings({ ...companySettings, ...newSettings })
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
			console.log(err)
		})
	}

	const changePlan = () => {
		setShowLoading(true)
		APIPost("companies/" + me.company_id + "/changeplan").then(res => {
			setShowLoading(false)
			setAlertType({ type: "success", text: "Request sent, you will be contacted by our sales team" })
			setShowAlert(true)
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ type: "error", text: err.response.data })
			setShowAlert(true)
		})
	}


	const uploadLogo = (files) => {
		const filesInfo = files.map(({ file, ...f }) => f);
		APIPost("companies/" + company_id + "/files", { files: filesInfo, action: "get_upload_url" }).then(res => {
			const file = files[0];
			const preSignedUrl = res.data.upload_urls;
			const headers = { "Content-Type": file.type, 'x-amz-acl': 'public-read' };
			return axios.put(preSignedUrl, file.file, { headers }).then(res => {
				const newFileName = preSignedUrl.split("?X-Amz")[0].replace("-sibilus-eu.s3.amazonaws.com", ".sibilus.eu");
				setFiles([])
				saveSettings({ logo: newFileName })
			}).catch(err => {
				setAlertType({ type: "error", text: "An error happened" })
				setShowAlert(true)
				console.log(err)
			})
		}).catch(err => console.log(err))
	};

	useEffect(() => {
		if (!userRoles.includes("company_administrator")) {
			setActiveTab("Whistles")
		} else {
			getCompanySettings()
			setUpdateData(false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [me, updateData])


	if (!companySettings) {
		return (<>
			<Loading
				showLoading={showLoading}
				inFront
			/>
		</>)
	}

	return companySettings && (
		<>
			<ContentHeader>
				<T>Company</T>
			</ContentHeader>
			<Tab {...tabProps} />
			<SettingsContent settingsTab={settingsTab} >
				<CompanyDetails
					tabId="CompanyDetails"
					changePlan={changePlan}
					companySettings={companySettings}
					setCompanySettings={setCompanySettings}
					files={files}
					setFiles={setFiles}
					saveSettings={saveSettings}
					uploadLogo={uploadLogo}
				/>
				<LinkGenerator
					tabId="Links"
				/>
				<CompanyDocuments
					company={companySettings}
					tabId="CompanyDocuments"
				/>
			</SettingsContent>
			<Loading
				showLoading={showLoading}
				inFront
				overlay
			/>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
		</>
	)
}

export default CompanySettings
